import { watch } from '@vue/composition-api'
import Vue from 'vue'

export default ({
  dependencies,
  predicate = value => !!value
}) => new Promise(resolve => {
  if (!dependencies) {
    resolve()
  } else {
    const unwatch = watch(
      dependencies,
      value => {
        if (predicate(value)) {
          resolve(value)
          Vue.nextTick(() => {
            unwatch()
          })
          return
        }
      }, {
        immediate: true
      }
    )
  }
})
